<!-- Agent status dropdown -->
<div appBringozIdGenerator="agentStatusesMenuBtn"
     ngbDropdown
     container="body"
     #mainDropdown="ngbDropdown"
     (openChange)="onMainMenuOpen($event)">

    <button id="agentStatusDropdown"
            appBringozIdGenerator="openStatusMenuBtn"
            class="agent-status-button layout-row layout-align-start-center"
            [ngClass]="{'OnDuty': status === agentStatusTypes.OnDuty ,'OnDutyOnBreak': status === agentStatusTypes.OnDutyOnBreak,
       'OffDuty': status === agentStatusTypes.OffDuty, 'menu-button': isLarge, 'outline': isOutline}"
            (click)="$event.stopPropagation()"
            [ngbTooltip]="statusTooltipTpl"
            [disableTooltip]="isDropdownOpen"
            placement="top"
            container="body"
            openDelay="300"
            triggers="hover"
            ngbDropdownToggle>

      <bringoz-icon *ngIf="!isLarge" iconName="menu" fill="#7E7E7E"></bringoz-icon>

      <span *ngIf="isLarge" class="margin-right-10">{{statusLabels[status]}}</span>

      <bringoz-icon *ngIf="isLarge && !isLoading"
                    fill="#FFFFFF"
                    iconName="chevron-down">
      </bringoz-icon>

      <div *ngIf="isLarge && isLoading" class="spinner-border margin-left-5" role="status">
        <span class="sr-only"></span>
      </div>

    </button>


  <div ngbDropdownMenu aria-labelledby="agentStatusDropdown" class="padding-top-10 padding-bottom-10">

    <!-- On Duty with timekeeping submenu -->
    <div *ngIf="status !== agentStatusTypes.OnDuty && !isBreakChangeBlocked" class="dropdown-item-container">

      <!-- Timekeeping enabled: Show nested dropdown -->
      <div *ngIf="isTimekeepingEnabled" ngbDropdown #onDutyDropdown="ngbDropdown" placement="right-top" container="body">
        <button ngbDropdownToggle
                class="agent-status-option full-width dropdown-item"
                appBringozIdGenerator="changeToOnDutyStatusBtn"
                (mouseenter)="onOnDutyMenuOpen(); onDutyDropdown.open()">
          <div class="layout-row layout-align-start-center">
            <div class="status-dropdown-indicator OnDuty margin-right-10"></div>
            <span class="br-body-2" flex>{{statusLabels[agentStatusTypes.OnDuty]}}</span>
            <bringoz-icon iconName="chevron-right" fill="#718096" classSize="s"></bringoz-icon>
          </div>
        </button>
        <div ngbDropdownMenu
             class="timekeeping-menu-content"
             (mousedown)="$event.target === $event.currentTarget && $event.stopPropagation()"
             (mouseup)="$event.target === $event.currentTarget && $event.stopPropagation()">

          <!-- Default Provider OR enforceResourceBasedLogin=false: Show clickable Clock-In button -->
          <button *ngIf="!loadingProfile && canClockInWithoutResource()"
                  ngbDropdownItem
                  class="agent-status-option full-width timekeeping-entry"
                  (click)="changeStatus(agentStatusTypes.OnDuty)">
            <div class="layout-row layout-align-start-center gap-5">
              <div class="timekeeping-indicator OnDuty"></div>
              <span class="br-body-1">Clock-In</span>
            </div>
          </button>

          <!-- Shift/Route Provider: Show loading spinner and resources list -->
          <ng-container *ngIf="!isDefaultProvider()">
            <!-- Loading spinner -->
            <div *ngIf="loadingProfile || loadingResources" class="timekeeping-loading padding-vertical-10">
              <div class="spinner-border spinner-border-sm" role="status">
                <span class="sr-only"></span>
              </div>
            </div>

            <!-- Empty message (only when enforceResourceBasedLogin=true) -->
            <div *ngIf="!loadingProfile && !loadingResources && isEnforceResourceBasedLogin() && clockInResources.length === 0"
                 class="timekeeping-empty padding-vertical-10">
              <span class="br-body-2">No available shifts/routes</span>
            </div>

            <!-- Resources list -->
            <ng-container *ngIf="!loadingProfile && !loadingResources">
              <button *ngFor="let resource of clockInResources"
                      ngbDropdownItem
                      class="agent-status-option full-width timekeeping-entry"
                      (click)="changeStatus(agentStatusTypes.OnDuty, resource)">
                <div class="layout-row layout-align-start-center gap-5">
                  <span class="br-body-1">{{resource.name}}</span>
                  <span class="br-body-1">{{resource | bringozTime: 'startTime'}} – {{resource | bringozTime: 'endTime'}}</span>
                </div>
              </button>
            </ng-container>
          </ng-container>

          <!-- Advance button -->
          <button *ngIf="!loadingProfile && !loadingResources"
                  ngbDropdownItem
                  class="agent-status-option full-width timekeeping-advance"
                  (click)="onAdvanceClick($event)">
            <div class="layout-row layout-align-start-center gap-5">
              <div class="timekeeping-indicator advance-indicator"></div>
              <span class="br-body-1 advance-text">Advance</span>
            </div>
          </button>
        </div>
      </div>

      <!-- Timekeeping disabled: Simple button -->
      <button *ngIf="!isTimekeepingEnabled"
              ngbDropdownItem
              class="agent-status-option full-width"
              appBringozIdGenerator="changeToOnDutyStatusBtn"
              (click)="changeStatus(agentStatusTypes.OnDuty);">
        <div class="layout-row layout-align-start-center">
          <div class="status-dropdown-indicator OnDuty margin-right-10"></div>
          <span class="br-body-2" flex>{{statusLabels[agentStatusTypes.OnDuty]}}</span>
        </div>
      </button>
    </div>

    <button *ngIf="status === agentStatusTypes.OnDuty"
            ngbDropdownItem
            class="agent-status-option full-width"
            appBringozIdGenerator="changeToOnBreakStatusBtn"
            (click)="changeStatus(agentStatusTypes.OnDutyOnBreak);">
      <div class="layout-row layout-align-start-center">
        <div class="status-dropdown-indicator OnDutyOnBreak margin-right-10"></div>
        <span class="br-body-2" flex>{{statusLabels[agentStatusTypes.OnDutyOnBreak]}}</span>
      </div>
    </button>

    <button *ngIf="status !== agentStatusTypes.OffDuty && !isBreakChangeBlocked"
            ngbDropdownItem
            class="agent-status-option full-width"
            appBringozIdGenerator="changeToOffDutyStatusBtn"
            (click)="changeStatus(agentStatusTypes.OffDuty);">
      <div class="layout-row layout-align-start-center">
        <div class="status-dropdown-indicator OffDuty margin-right-10"></div>
        <span class="br-body-2" flex>{{statusLabels[agentStatusTypes.OffDuty]}}</span>
      </div>
    </button>

    <!-- Active break info -->
    <div *ngIf="activeBreak" class="break-status-card layout-column gap-5">
      <span class="br-body-2 break-status-title">{{'Break Status' | translate}}</span>

      <div class="layout-row layout-align-start-center gap-5">
        <div class="timekeeping-indicator OnDutyOnBreak"></div>
        <span class="br-body-2">{{activeBreak.breakType.name}}</span>
        <span class="br-caption-2 break-status-secondary">({{(activeBreak.breakType.paid ? 'Paid' : 'Unpaid') | translate}})</span>
      </div>

      <span class="br-body-2 break-status-secondary">
        {{'Break' | translate}} {{activeBreak | bringozTime: 'startTime'}} – {{activeBreak | bringozTime: 'endTime' : ('Unlimited' | translate)}}
      </span>

      <div *ngIf="isBreakChangeBlocked || isBreakChangeWarning"
           class="break-status-message layout-row layout-align-start-start gap-5"
           [ngClass]="{'blocked': isBreakChangeBlocked}">
        <bringoz-icon iconName="error" classSize="sm" [fill]="isBreakChangeBlocked ? '#D52424' : '#BF6A28'"></bringoz-icon>
        <span *ngIf="isBreakChangeBlocked" class="br-caption-2">{{'BREAK_MUST_BE_COMPLETED' | translate: {minutes: activeBreak.remainingMinutes} }}</span>
        <span *ngIf="isBreakChangeWarning" class="br-caption-2">{{'BREAK_TIME_NOT_ENDED' | translate: {minutes: activeBreak.remainingMinutes} }}</span>
      </div>
    </div>

  </div>
</div>

<ng-template #statusTooltipTpl>
  <span *ngIf="statusUpdatedAt" class="br-body-2 font-weight-400">
    {{'Status since' | translate}}: {{statusUpdatedAt | date: 'MMM d, y'}} – {{statusUpdatedAt | date: 'hh:mm a'}}
  </span>
  <span *ngIf="!statusUpdatedAt" class="br-body-2 font-weight-400">
    {{'Status change time unavailable' | translate}}
  </span>
</ng-template>
